import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({

  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    // 存储loginName
    loginName: localStorage.getItem('loginName') ? localStorage.getItem('loginName') : ''
  },

  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, user) {
      state.Authorization = user.Authorization
      state.loginName = user.loginName
      localStorage.setItem('Authorization', user.Authorization)
      localStorage.setItem('loginName', user.loginName)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js